import Emitter from 'emitter-js'

export default {
  install (Vue, options) {
    Vue.prototype.$hub = new Emitter()
  }
}
